import {Middleware} from "redux";
import {isFulfilled, isRejected} from "@reduxjs/toolkit";
import {API_SUCCESS} from "../types";

export const responseStateMiddleware: Middleware = () => (next) => (action) => {
    if (isFulfilled(action)) {
        if (document) {
            document.dispatchEvent(
                new CustomEvent(API_SUCCESS, {detail: {success: true}})
            );
        }
    } else if (isRejected(action)) {
        if (
            action.payload &&
            typeof action.payload === "object" &&
            "status" in action.payload &&
            action.payload?.status === 401 &&
            document &&
            !window.location.hostname.includes("localhost")
        ) {
            // Redirect to login page. Not sure if this is a good way to do it.
            const returnUrl = encodeURIComponent(
                window.location.pathname + window.location.search
            );

            window.location.href = "/auth/dib_login?returnUrl=" + returnUrl;
        }
    }

    return next(action);
};
